<ng-container *ngIf="order$ | async as order; else loading">
  <h3 id="documents" class="eb-order-detail-documents__title">
    {{ 'orderDetails.documents.title' | cxTranslate }}
  </h3>
  <ng-container *ngIf="order.documents && order.documents.length > 0; else noDocuments">
    <ng-container *ngIf="dataStructure$ | async as structure">
      <cx-table
        [structure]="structure"
        [data]="order.documents"
        [i18nRoot]="'orderDetails.documents'"
        class="order-history-documents-table"
      >
      </cx-table>
    </ng-container>
  </ng-container>
  <ng-template #noDocuments>
    <li class="eb-order-detail-documents__item">
      <span class="col-12">
        {{ 'orderDetails.documents.noDocumentsAvailable' | cxTranslate }}
      </span>
    </li>
  </ng-template>
</ng-container>
<ng-template #loading>
  <eb-spinner class="my-3 d-block"></eb-spinner>
</ng-template>
